export const resources = {
  InsightsTablistLabel: '',
  Preview: ''
};
